<script>
	import { onMount, tick } from "svelte";
	import { projectSettings } from "../config";
	import { validator } from "../validation";

	export let id = null;
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let required = false;
	export let disabled = false;
	export let placeholder = null;

	const authorization = `Basic ${projectSettings.loqateCredentials}`;
	const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[\s/0-9]{9,12}$/;

	let inputEl;
	let isValidating = false;
	let isValid = !value || phoneRegex.test(value);
	let retryCount = 0;
	let retryLimit = 2;
	let lastValidatedNumber = null;
	let validationRequest = 0;

	async function validatePhone(phoneNumber) {
		const responseOptions = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: authorization
			},
			body: JSON.stringify({
				payload: [{ fullPhone: phoneNumber, country: "AU" }]
			})
		};

		try {
			const response = await fetch("https://hosted.mastersoftgroup.com/harmony/rest/AU/validate/phone", responseOptions);
			if (!response.ok) throw new Error("Loqate phone validation failed");

			const responseData = await response.json();
			const isValidResponse = !!responseData.payload?.[0] && !responseData.payload[0].exception;
			retryCount = 0;

			return { success: isValidResponse };
		} catch {
			if (retryCount++ >= retryLimit) {
				return { timeout: true };
			}

			return validatePhone(phoneNumber);
		}
	}

	async function validateValue(rawValue) {
		const phoneNumber = (rawValue || "").trim();

		$validator.clearVisualError(inputEl);

		if (!phoneNumber || !phoneRegex.test(phoneNumber)) {
			validationRequest++;
			lastValidatedNumber = null;
			isValid = !phoneNumber;
			isValidating = false;
			await tick();
			$validator.validate(inputEl);
			return;
		}

		if (phoneNumber === lastValidatedNumber) {
			if (!isValidating) {
				$validator.validate(inputEl);
			}
			return;
		}

		const request = ++validationRequest;
		lastValidatedNumber = phoneNumber;
		isValid = false;
		isValidating = true;

		try {
			const status = await validatePhone(phoneNumber);

			if (request !== validationRequest) return;
			isValid = status.success || status.timeout;
		} finally {
			if (request === validationRequest) {
				isValidating = false;
				await tick();
				$validator.validate(inputEl);
			}
		}
	}

	function handleValueChange(event) {
		validateValue(event.currentTarget.value);
	}

	onMount(() => {
		if (value) {
			validateValue(value);
		}
	});
</script>

{#if label}
	<label for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
<input
	bind:this={inputEl}
	{id}
	class="form-control"
	type="tel"
	{required}
	{disabled}
	{placeholder}
	{maxlength}
	bind:value
	data-validator="telinput"
	data-isvalid-tel={isValid}
	on:input={handleValueChange}
	on:change={handleValueChange}
/>

<div id="{id}_error" class="tel-input-error">
	{#if isValidating}
		<div class="error-message" style="color:orange">Validating...</div>
	{/if}
</div>
